import { STORAGE_KEYS } from '../../utils/constants/storageKeys';
import { AskAicaPrompts, PlayMode } from './AskAicaOrb.types';

/** Inside a company's AICA report — the second text names the company. */
export function getCompanyPrompts(companyName?: string): AskAicaPrompts {
    return ['Ask anything about the company...', companyName ? `What are ${companyName}'s key risks?` : 'What are its key risks?'];
}

// The playKey (company id, or 'portfolio') the orb last animated for. Kept in
// memory only: a page reload counts as a fresh entry.
let lastPlayedKey: string | null = null;

function readSeenKeys(): string[] {
    try {
        const parsed = JSON.parse(window.sessionStorage.getItem(STORAGE_KEYS.ASK_AICA_ORB_SEEN_KEYS) ?? '[]');
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
}

function markSeen(playKey: string): void {
    try {
        const seen = readSeenKeys();
        if (!seen.includes(playKey)) {
            window.sessionStorage.setItem(STORAGE_KEYS.ASK_AICA_ORB_SEEN_KEYS, JSON.stringify([...seen, playKey]));
        }
    } catch {
        // Storage unavailable (e.g. private mode) — the questions may simply play again.
    }
}

export function decidePlayMode(playKey?: string): PlayMode {
    if (!playKey) return 'full';
    if (lastPlayedKey === playKey) return 'static';
    return readSeenKeys().includes(playKey) ? 'short' : 'full';
}

/** Records that `playKey`'s sequence has started — an imported binding can't
 * be reassigned, so callers use this instead of touching `lastPlayedKey` directly. */
export function markPlayed(playKey: string): void {
    lastPlayedKey = playKey;
    markSeen(playKey);
}
